import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { URL } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OpenaiService {

  constructor(private http: HttpClient) { }

  sendMessage(text: string, threadId?: string) {
    const url = `${URL}/general/ask-assistant`;

    return this.http.post(url, { text, threadId });
  }
}
